import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import { customStyle, numberFormat } from 'helper';
import * as actions from '../../../action';
import * as c from '../../../constant';
import LandStripFrontAgesComponent from '../component/LandStripFrontAgesComponent';
import SubClassification from '../component/SubClassification';

const actualUseToType = (item) => {
  switch (item) {
    case 'Residential':
      return 'Stripage';
    case 'Commercial':
      return 'Frontage';
    default:
      return '';
  }
};

function LandAppraisalModal({
  applicationId,
  createLandAppraisal,
  getLandAppraisalList,
  id,
  history,
  getLandSubClassificationList,
  getLandClassificationsList,
  landClassificationsList,
  getSingleLandClass,
  getLandPropertyAssessmentList,
  getSingleLandApplication,
  getActualUseList,
  actualUseList,
  // subClassificationList,
  type,
  ordinanceRevisionId,
  updateList,
  updateLandAppraisal,
  getSingleLandSubClass,
}) {
  const setModal = useContext(ModalContext);
  const [selected, setSelected] = useState({
    name: '',
    street_from: '',
    street_to: '',
    land_sub_classification_code: '',
    unit_value: '',
  });
  const [formData, setFormData] = useState({
    rptax_land_classification_id: '',
    rptax_land_buv_id: '',
    rptax_actual_use_id: '',
  });

  const commonValidation = {
    rptax_land_classification_id: 'required',
    rptax_land_buv_id: 'required',
    rptax_actual_use_id: 'required',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleChange = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data,
    });
  };

  useEffect(() => {
    getLandClassificationsList({ isPaginate: 1, status: 1 });
    getActualUseList({ status: 1 });

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const validation = Object.values(
      _.get(formData, 'rptax_land_strip_frontages')
    ).every((x) => x.area === null || x.area === '' || x.area === 0);

    const args = {
      ...formData,
      rptax_land_strip_frontages: formData?.rptax_land_strip_frontages.map(
        (item) => _.omit(item, ['localId'])
      ),
    };

    if (validation === true) {
      Alert.error('You needed to input value in area');
    } else {
      if (type === 'NEW') {
        createLandAppraisal(applicationId, args, () => {
          setModal({ isOpen: false });
          getLandPropertyAssessmentList(applicationId);
          getLandAppraisalList(applicationId);
          getSingleLandApplication(applicationId);
          history.push(`/rpt/land/applications/${applicationId}`);
        });
      }

      if (type === 'EDIT') {
        updateLandAppraisal(applicationId, id, args, (data) => {
          setModal({ isOpen: false });
          getLandPropertyAssessmentList(
            _.get(data, 'data.attributes.rptax_land_application_id')
          );
          getLandAppraisalList(
            _.get(data, 'data.attributes.rptax_land_application_id')
          );
          getSingleLandApplication(applicationId);
          history.push(
            `/rpt/land/applications/${_.get(
              data,
              'data.attributes.rptax_land_application_id'
            )}`
          );
        });
      }
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const createDropDown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  // const createDropdownLandSubClass = list => {
  //   const newList = [];
  //   list.map(data => {
  //     return newList.push({
  //       name: data.attributes.rptax_location_name,
  //       street_from: data.attributes.street_from,
  //       street_to: data.attributes.street_to,
  //       land_sub_classification_code: data.attributes.land_sub_classification_code,
  //       unit_value: data.attributes.unit_value,
  //       value: data.id,
  //       rptax_land_sub_classification_id: data.attributes.land_sub_classification_id,
  //     });
  //   });
  //   return newList;
  // };

  const handleLandClassSelect = (e) => {
    setSelected({});

    setFormData({
      ...formData,
      rptax_land_classification_id: e.value,
      classification: e.label,
      rptax_land_sub_classification_id: '',
      rptax_land_buv_id: '',
      sub_classification: '',
    });
    getLandSubClassificationList(applicationId, {
      rptax_land_classification_id: e.value,
      ordinance_revision_id: ordinanceRevisionId
    });

    getActualUseList({ status: 1 });
  };

  const handleLandSubClassSelect = (e) => {
    if (!_.isEmpty(selected.name)) {
      setSelected({});
      getSingleLandSubClass(e.target.value, (item) => {
        setSelected({
          name: _.get(item, 'data.attributes.rptax_location_name'),
          street_from: _.get(item, 'data.attributes.street_from'),
          street_to: _.get(item, 'data.attributes.street_to'),
          land_sub_classification_code: _.get(
            item,
            'data.attributes.land_sub_classification_code'
          ),
          unit_value: _.get(item, 'data.attributes.unit_value'),
        });
      });
    } else {
      getSingleLandSubClass(e.target.value, (item) => {
        setSelected({
          name: _.get(item, 'data.attributes.rptax_location_name'),
          street_from: _.get(item, 'data.attributes.street_from'),
          street_to: _.get(item, 'data.attributes.street_to'),
          land_sub_classification_code: _.get(
            item,
            'data.attributes.land_sub_classification_code'
          ),
          unit_value: _.get(item, 'data.attributes.unit_value'),
        });
      });
    }

    if (_.get(formData, 'rptax_land_strip_frontages').length >= 1) {
      setFormData({
        ...formData,
        rptax_land_sub_classification_id:
          e.target.rptax_land_sub_classification_id,
        sub_classification: e.target.land_sub_classification_code,
        rptax_land_strip_frontages: [],
        rptax_land_buv_id: e.target.value,
      });
    }
    setFormData({
      ...formData,
      rptax_land_sub_classification_id:
        e.target.rptax_land_sub_classification_id,
      sub_classification: e.target.land_sub_classification_code,
      rptax_land_buv_id: e.target.value,
      rptax_land_strip_frontages: [
        {
          area: 0,
          unit_value: e.target.unit_value,
          base_market_value: 0,
          type: null,
        },
      ],
      default_strip_frontage: [
        {
          area: 0,
          unit_value: e.target.unit_value,
          base_market_value: 0,
          type: null,
        },
      ],
    });
  };

  const handleActualUseSelect = (e) => {
    // setActualUse(e);
    setFormData({
      ...formData,
      rptax_actual_use_id: e.value,
      actual_use: e.label,
      type: actualUseToType(e.label),
      rptax_land_strip_frontages:
        formData.default_strip_frontage ||
        c.LAND_APPRAISAL_FORM_DATA.rptax_land_strip_frontages,
    });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        rptax_land_strip_frontages: updateList?.rptax_land_strip_frontages?.map(
          (item) => ({
            ...item,
            localId: item.id,
          })
        ),
      };
      getSingleLandClass(_.get(updateList, 'rptax_land_classification_id'));
      getSingleLandSubClass(_.get(updateList, 'rptax_land_buv_id'), (item) => {
        setSelected({
          name: _.get(item, 'data.attributes.rptax_location_name'),
          street_from: _.get(item, 'data.attributes.street_from'),
          street_to: _.get(item, 'data.attributes.street_to'),
          land_sub_classification_code: _.get(
            item,
            'data.attributes.land_sub_classification_code'
          ),
          unit_value: _.get(item, 'data.attributes.unit_value'),
        });
        setFormData(
          _.pick(
            {
              ...args,
              default_strip_frontage: [
                {
                  area: 0,
                  unit_value: _.get(item, 'data.attributes.unit_value'),
                  base_market_value: 0,
                  type: null,
                },
              ],
            },
            _.keys(c.LAND_APPRAISAL_FORM_DATA)
          )
        );
      });
      getLandSubClassificationList(applicationId, {
        rptax_land_classification_id: _.get(
          updateList,
          'rptax_land_classification_id'
        ),
        ordinance_revision_id: ordinanceRevisionId,
      });
      getActualUseList({ status: 1 });
    }
  };

  useEffect(() => {
    if (type === 'NEW') {
      setFormData({
        ...formData,
        rptax_land_strip_frontages: [
          {
            area: 0,
            unit_value: 0,
            base_market_value: 0,
          },
        ],
      });
    }
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const classificationOptions = landClassificationsList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Land Classification &nbsp;{' '}
              {validateForm.renderMessage('rptax_land_classification_id')}
            </label>
            <div>
              <Select
                options={classificationOptions}
                styles={customStyle}
                placeholder="Select Land Classification"
                value={
                  classificationOptions.filter(
                    (item) =>
                      +_.get(formData, 'rptax_land_classification_id') ===
                      +_.get(item, 'value')
                  ) || ''
                }
                onChange={(e) => {
                  handleLandClassSelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Location &nbsp; {validateForm.renderMessage('rptax_land_buv_id')}
            </label>
            <div>
              <SubClassification
                name="rptax_land_buv_id"
                onChange={(e) => {
                  handleLandSubClassSelect(e);
                }}
                value={`${_.get(formData, 'rptax_land_buv_id')}` || ''}
                id={applicationId}
                ordinanceRevisionId={ordinanceRevisionId}
              />
            </div>
          </div>
          {!_.isEmpty(selected.name) && (
            <div className="col-12 form-group">
              <div className="border-dotted">
                <div className="row">
                  <div className="col-12">
                    <span className="font-weight-bold">
                      <h4>{selected.name}</h4>
                    </span>
                  </div>
                  <div className="col-12">
                    <small>Street From: {selected.street_from}</small>
                  </div>
                  <div className="col-12">
                    <small>Street To: {selected.street_to}</small>
                  </div>
                  <div className="col-12">
                    <small>
                      Land Sub-Classification Code:{' '}
                      {selected.land_sub_classification_code}
                    </small>
                  </div>
                  <div className="col-12">
                    <small>
                      Unit Value: {numberFormat(selected.unit_value)}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="col-12 form-group">
            <label className="form-label">
              Actual Use &nbsp;{' '}
              {validateForm.renderMessage('rptax_actual_use_id')}
            </label>
            <div>
              <Select
                options={createDropDown(actualUseList)}
                styles={customStyle}
                placeholder="Select Actual Use"
                value={
                  createDropDown(actualUseList).filter(
                    (item) =>
                      +_.get(formData, 'rptax_actual_use_id') ===
                      +_.get(item, 'value')
                  ) || ''
                }
                onChange={(e) => {
                  handleActualUseSelect(e);
                }}
              />
            </div>
          </div>
          <LandStripFrontAgesComponent
            value={formData.rptax_land_strip_frontages || []}
            onChange={handleChange('rptax_land_strip_frontages')}
            formData={formData}
            type={formData.type}
            setFormData={setFormData}
          />
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

LandAppraisalModal.defaultProps = {
  type: '',
  updateList: {},
  id: '',
};

LandAppraisalModal.propTypes = {
  applicationId: PropTypes.string.isRequired,
  getLandAppraisalList: PropTypes.instanceOf(Function).isRequired,
  createLandAppraisal: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  getSingleLandClass: PropTypes.instanceOf(Function).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  landClassificationsList: PropTypes.instanceOf(Array).isRequired,
  getLandSubClassificationList: PropTypes.instanceOf(Function).isRequired,
  // subClassificationList: PropTypes.instanceOf(Array).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string,
  ordinanceRevisionId: PropTypes.number.isRequired,
  updateList: PropTypes.instanceOf(Object),
  updateLandAppraisal: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
  getLandPropertyAssessmentList: PropTypes.instanceOf(Function).isRequired,
  getSingleLandSubClass: PropTypes.instanceOf(Function).isRequired,
  getSingleLandApplication: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  landClassificationsList:
    _.get(api, `${c.GET_LAND_CLASSIFICATIONS}.list`) || [],
  subClassificationList:
    _.get(api, `${c.GET_LAND_SUB_CLASSIFICATIONS}.list`) || [],
  actualUseList: _.get(api, `${c.GET_ACTUAL_USES}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(LandAppraisalModal);
